import { View, Text } from "react-native";
import { Ban } from "lucide-react-native";
import { EMBER } from "../../../onboarding/theme";

import { ListRowSkeleton, cardSurface } from "@louise/moon-ui";

export default function WhatNotToDoCard() {
  return (
    <View style={{ ...cardSurface(), padding: 16 }}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 8,
          marginBottom: 8,
        }}
      >
        <Ban size={14} color={EMBER.colors.textLight} strokeWidth={1.75} />
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 15,
            fontWeight: "600",
            color: EMBER.colors.text,
          }}
        >
          What not to do
        </Text>
      </View>
      <ListRowSkeleton showSubtitle />
      <ListRowSkeleton showSubtitle />
      <ListRowSkeleton showSubtitle />
    </View>
  );
}
